import React from "react";
import { bool, node, string } from "prop-types";
import LandingSimpleSection from "../LandingElement/SimpleSection";

const CardBlockSection = ({
	id = "",
	title = "",
	children = null,
	isBorderNone = true,
	...props
}) => (
	<LandingSimpleSection id={id} isBorderNone={isBorderNone} {...props}>
		{title ? <LandingSimpleSection.Title>{title}</LandingSimpleSection.Title> : null}
		{children}
	</LandingSimpleSection>
);

CardBlockSection.propTypes = {
	isBorderNone: bool,
	id: string,
	title: string,
	children: node,
};

export default CardBlockSection;
